import {
  UPDATE_DASHBOARD_STACK_STATISTICS,
  UPDATE_DASHBOARD_MEASUREMENT_CARD,
  UPDATE_DASHBOARD_FILTER_OPTIONS,
  UpdateDashboardStackStatistics,
  UpdateDashboardMeasurementCard,
} from '../store/dashboard';
import { ApiService } from '../services/apiService';
import {
  MeasurementCardResponse,
  StackFilterOptionsQueryRequest,
  StackFilterOptionsResponse,
  StackStatisticsQueryRequest,
  StackStatisticsResponse,
} from '.generated/api';
import { notificationActions } from './notificationActions';
import { ApplicationState, AppDispatch } from 'store';

export const dashboardActions = {
  getStackStatistics,
  getOrganizationMeasurementCard,
};

function updateDashboardFilterOptions(
  filterOptions?: StackFilterOptionsResponse | null,
) {
  return { type: UPDATE_DASHBOARD_FILTER_OPTIONS, filterOptions };
}

function updateDashboardStackStatistics(
  stackStatistics?: StackStatisticsResponse | null,
  filters?: StackStatisticsQueryRequest,
): UpdateDashboardStackStatistics {
  return { type: UPDATE_DASHBOARD_STACK_STATISTICS, stackStatistics, filters };
}

function updateDashboardMeasurementCard(
  measurementCard?: MeasurementCardResponse | null,
): UpdateDashboardMeasurementCard {
  return { type: UPDATE_DASHBOARD_MEASUREMENT_CARD, measurementCard };
}

function getStackFilterOptions(filters: StackFilterOptionsQueryRequest) {
  return (dispatch: AppDispatch) => {
    // dispatch(updateDashboardFilterOptions(undefined)); // signal loading
    ApiService.getStackFilterOptions(filters)
      .then((response) => {
        dispatch(updateDashboardFilterOptions(response.data));
      })
      .catch((error) => {
        dispatch(updateDashboardFilterOptions(null)); // signal no data
        dispatch(notificationActions.enqueueErrorResponse(error));
      });
  };
}

function getStackStatistics(filters: StackStatisticsQueryRequest) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    if (filters.departmentIds.length === 0) {
      dispatch(updateDashboardStackStatistics(null)); // clear statistics
      dispatch(updateDashboardFilterOptions(null)); // clear filter options
    } else {
      if (filters.from && filters.to) {
        const prevFilters = getState().dashboard.filters;
        if (
          !prevFilters ||
          prevFilters.from !== filters.from ||
          prevFilters.to !== filters.to ||
          prevFilters.departmentIds !== filters.departmentIds
        ) {
          dispatch(
            getStackFilterOptions({
              departmentIds: filters.departmentIds,
              from: filters.from,
              to: filters.to,
            }),
          );
        }
      }

      dispatch(updateDashboardStackStatistics(undefined)); // indicate loading
      ApiService.getStackStatistics(filters)
        .then((response) => {
          dispatch(updateDashboardStackStatistics(response.data, filters));
        })
        .catch((error) => {
          dispatch(updateDashboardStackStatistics(null, filters));
          dispatch(notificationActions.enqueueErrorResponse(error));
        });
    }
  };
}

function getOrganizationMeasurementCard(orgId: string) {
  return (dispatch: AppDispatch) => {
    dispatch(updateDashboardMeasurementCard(undefined)); // indicate loading
    ApiService.getOrganizationMeasurementCard(orgId)
      .then((response) => {
        dispatch(updateDashboardMeasurementCard(response.data));
      })
      .catch((error) => {
        dispatch(updateDashboardMeasurementCard(null));
        dispatch(notificationActions.enqueueErrorResponse(error));
      });
  };
}
